import React from 'react';
import { FaDiscord } from 'react-icons/fa';

function Join() {
  return (
    <div className='container back text-center text-white py-5' style={{marginTop:"13%"}}>
        <FaDiscord className='fs-1 mb-3' />
        <h2 className="">Join Our Community</h2>
        <button className='btn btn-light px-3 fw-bold' style={{borderRadius:"50pc", color:"#ff7844"}}>Join Discord</button>
    </div>
  );
}

export default Join;
